import React, { useState } from 'react';
import { returnSaneURL } from '../../../../Utils/getImg';
import { TString } from '../../../FeatureComponents/Response/Utils';
import Cards from '../../../FeatureComponents/Response/Templates/Cards/Cards';
interface Props {
	data: any;
	handleSubmit: Function;
	botImageCheck: boolean;
	index: number;
	logoImagePath: string;
	shouldDisableActions: boolean;
	voiceResponse: boolean;
	timeStamp: string;
	channel: string;
}

const WAMultiChoice = (props: Props) => {
	let { data, handleSubmit, voiceResponse } = props;
	const [optionsPopup, setOptionsPopup] = useState(false);
	const handleOpenPopup = (data) => {
		setOptionsPopup(true);
		console.log(data);
	};
	return (
		<div
			className='sf-whatsapp-multiple-w'
			tabIndex={voiceResponse || props.shouldDisableActions ? -1 : 0}
		>
			{props.botImageCheck && props.index == 0 ? (
				<div className={'preview-image-holder'}>
					<img
						src={returnSaneURL(props.logoImagePath)}
						alt={TString({ labelName: 'botAvatarLabel' })}
					/>
				</div>
			) : null}
			<div
				className='sf-whatsapp-title-time'
				tabIndex={voiceResponse || props.shouldDisableActions ? -1 : 0}
			>
				<div
					className='sf-whatsapp-title body-text-1'
					dangerouslySetInnerHTML={{
						__html: data.displayResponse,
					}}
				/>
				<p className='whatsApp-time'>{props.timeStamp}</p>
			</div>
			<div className={'sf-whatsapp-multiple-result-w multi-result'}>
				{data.lists.items.map((eachOption, index) => {
					console.log(eachOption)
					return (
						<div
							key={index}
							style={
								props.shouldDisableActions ? { cursor: 'not-allowed' } : {}
							}
						>
							<Cards
								key={eachOption.title}
								{...eachOption}
								//   onClick={()=>handleSubmit(eachOption.title)}
								disabled={props.shouldDisableActions}
								typeGrid
								handleSubmit={handleSubmit}
								timeStamp={props.timeStamp}
								channel={props.channel}
								listsCount={data.lists.items.length}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};
export default WAMultiChoice;
